import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './nav.css';


export default class Nav extends React.Component {
    render() {

      
      return (
      
      <div class="nav-bar">



        
        <Link to="/">   <img src="./images/firstfloor_logo.svg" class="nav-logo"/> </Link>

        <div class="products">
        <Link to="/"> <p class="product-link-app"> iOS App </p> </Link>
        <Link to="/RoomService"> <p class="product-links-protocol"> RoomService </p> </Link>
       </div>





        {/* <a href="https://twitter.com/firstfloorapp" target="_blank"> <p class="social"> Twitter </p> </a> */}
      {/* <a href="https://discord.gg/nm4xRx42ww" target="_blank"><p class="social"> Discord </p></a> */}
      {/* <a href="mailto:firstfloorapp@gmail.com" target="_blank"> <p class="social"> Contact</p> </a> */}
      {/* <a href="https://t.co/P6ZIKg0bOU" class="button" target="_blank"><div ><p>Get the app</p></div></a> */}
      </div>

      );
    }
  }